import request from './request';

export interface Product {
  id: number;
  createdAt: string;
  updatedAt: string;
  productTypeId: number;
  productTypeIdPath: string;
  marketProductCode: string;
  name: string;
  enName: string;
  symbol: string;
  basicVolumePriceCurrencyId: number;
  description: string;
  prepaymentMaintenanceRate: number;
  tradingStartTime: string;
  tradingEndTime: string;
  leverType: number;
  levers: string;
  scale: number;
  openFee: number;
  closeFee: number;
  tpRatio: number;
  slRatio: number;
  maxAmount: number;
  minAmount: number;
  lotIncreaseStepSize: number;
  decimalPlaces: number;
  spread: number;
  fluctuationRange: number;
  billingCycleHours: number;
  fundRate: number;
  storageFee: number;
  sort: number;
  enableState: boolean;
  tradingState: boolean;
  allowBuy: boolean;
  allowSell: boolean;
  enableMarketPrice: boolean;
  enableLimitPrice: boolean;
  isShow: boolean;
  isHotSearch: boolean;
  createBy: string | null;
  updateBy: string | null;
}

/**
 * 获取所有产品列表
 */
export const fetchProducts = (): Promise<Product[]> => {
  return request.get('/market/api/v1/admin/market/products');
}; 